import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject, Injector } from '@angular/core';
import { Observable, throwError } from 'rxjs';
// import { UserProfileService } from './user-profile.service';
import { AuthService } from './auth.service';
import { IApiErrorResponse } from '../interfaces/IApiResponse.model';
import { Router } from '@angular/router';
import { Constants } from '../shared/constants';
import { SnackBarService } from './snack-bar.service';
// import { SnackBarService } from './snack-bar.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  // private userprofileService = inject(UserProfileService);
  private injector = inject(Injector);
  private router = inject(Router);
  private snackBarService = inject(SnackBarService);

  handleError(error?: ErrorEvent | HttpErrorResponse): Observable<never> {
    let errorMessage: string | object = '';
    if (!navigator.onLine) {
      errorMessage = 'No Internet Connection. Please check your internet provider';
    } else if (error && error instanceof HttpErrorResponse) {
      errorMessage = this.processErrorMessage(error);
    } else if (error?.error instanceof ErrorEvent) {
      errorMessage =
        error?.error?.message || error?.message || error?.error?.toString() || 'An error occurred';
    }
    this.snackBarService.openSnackBar(`${errorMessage}`, 'error');
    return throwError(() => errorMessage);
  }

  // returns a string of the error message from the IApiErrorResponse
  processErrorMessage(error: HttpErrorResponse): string | object {
    let message: string | object;
    const apiErrorResponse: IApiErrorResponse = error.error;
    console.error('API Error Response:', apiErrorResponse);
    switch (error.status) {
      case 401:
        message =
          typeof apiErrorResponse.message === 'string'
            ? apiErrorResponse.message
            : 'You are not logged in';
        this.logoutUnauthenticatedUser(); // logout user
        break;
      case 404:
      case 400:
      case 403:
      case 409:
      case 500:
        if (apiErrorResponse.errors && apiErrorResponse.errors.length > 0) {
          const errors = apiErrorResponse.errors;
          message = { message: apiErrorResponse.message, errors };
        } else if (apiErrorResponse.fieldErrors) {
          const fieldErrors = Object.values(apiErrorResponse.fieldErrors).join('<br/>');
          message = fieldErrors;
        } else if (
          typeof apiErrorResponse.message === 'string' &&
          typeof apiErrorResponse.error !== 'string'
        ) {
          message = apiErrorResponse.message;
        } else if (
          typeof apiErrorResponse.message === 'string' &&
          typeof apiErrorResponse.error === 'string'
        ) {
          message = apiErrorResponse.message || apiErrorResponse.error;
        } else if (
          typeof apiErrorResponse.message === 'object' &&
          Array.isArray(apiErrorResponse.message)
        ) {
          const messageArray: string[] = apiErrorResponse.message as string[];
          message = messageArray.join('<br/>');
        } else {
          message = 'An error occurred';
        }
        break;
      case 413:
        message = 'Content too large';
        break;
      case 422:
        if (error.error.message) {
          message = error.error.message;
        } else {
          message = error.message;
        }
        break;
      case 503:
        if (
          typeof apiErrorResponse.error === 'string' &&
          apiErrorResponse.error === 'Service Unavailable'
        ) {
          message = apiErrorResponse.message;
        } else {
          message = Constants.ERROR_503;
        }
        break;
      case 509:
        /**
         * To enhance this message, you could communicate that the 500 error is a generic indication of a problem and reassure the user that it's being addressed. Here's a refined version:
         * **/
        message = Constants.ERROR_500;
        break;
      default:
        message = `${JSON.stringify(apiErrorResponse?.message || 'An error occurred')}`;
        break;
    }
    return message;
  }

  logoutUnauthenticatedUser() {
    // this.userprofileService.updateProfile(null);
    const authService = this.injector.get(AuthService);
    authService.clearUserSessionData();
    authService.goToAuth(this.router.routerState.snapshot.url);
  }
}
